import { Identifiable, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function removeResourceFromPlanzoneAndTransferAllocations(
  httpClient: HttpClient,
) {
  return (from: Identifiable<Resource>, to: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<void>({
        endpoint: `/resources/${from.uuid}`,
        method: HttpMethods.DELETE,
        data: {
          source: from.uuid,
          destination: to.uuid,
        },
      })
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { removeResourceFromPlanzoneAndTransferAllocations };
